import { WizCoreTranslationManager } from '@wizeoo/akm-core-lib';
import { TranslatedEmb, TranslatedKeyPair } from '@wizeoo/akm-message-lib';
import { WizConstants } from '../../model/constants';
import { Model } from '../../model/model';


export interface ITranslator {
  translateKey(pKey: string, pParams?: string[], orDie?: string): string;
}
/** gestion de la locale / des traductions pour le moteur */
export class LocaleEngine implements ITranslator {

  /* Le modèle pour l'accés aux codes langues */
  protected _model: Model;
  public get model(): Model {
    return this._model;
  }
  public set model(value: Model) {
    this._model = value;
  }

  constructor(pmodel: Model) {
    this._model = pmodel;
  }

  /** accesseur sur le code de la locale par défaut BU, ou vide  => (en) */
  public getBuLocale(): string {
    return this.model.buLocaleCode;
  }

  /** accesseur sur le code de la locale (user) */
  public getLocale(): string {
    return this.model.currentLocaleCode;
  }

  /**
   * retourne la valeur du libellé dans la langue active (ou à minima dans la
   * langue par défaut)
   * @param label : champ à traduire de type TranslatableLabel
   */
  public translate(label: TranslatedEmb, alter: string = ''): string {
    return this.getTranslation(label, this.getLocale(), this.getBuLocale(), alter);
  }

  /**
   * retourne la valeur du libellé dans la langue active (ou à minima dans la
   * langue par défaut)
   * @param label : champ à traduire de type TranslatableLabel
   */
  public getTranslation(label: TranslatedEmb, userLanguage: string, defaultLanguage: string, alter: string = ''): string {
    let result: string = alter;
    if (label && label.keys) {
      let firstTrs: TranslatedKeyPair = null;
      let defaultTrs: TranslatedKeyPair = null;
      let localeTrs: TranslatedKeyPair = null;
      let userTrs: TranslatedKeyPair = null;
      Object.values(label.keys).forEach((kp: TranslatedKeyPair) => {
        if (!firstTrs) {
          firstTrs = kp;
        }
        if (kp.cod === defaultLanguage) {
          defaultTrs = kp;
        }
        if (kp.cod === WizConstants.defaultLocaleCode) {
          localeTrs = kp;
        }
        if (kp.cod === userLanguage) {
          userTrs = kp;
        }
      });

      if (userTrs) { // d'abord le user
        result = userTrs.val;
      } else if (defaultTrs) { // ou la langue par défaut de la bu
        result = defaultTrs.val;
      } else if (localeTrs) { // ou la locale
        result = localeTrs.val;
      } else if (firstTrs) { // ou le premier trouvé
        result = firstTrs.val;
      }
    }
    return result;
  }

  /**
   * Returns translated string from a translation key
   * @param pKey Translation key
   * @param pParams Array of values to be included inside the result string.
   * @param orDie valeur par défaut si pas trouvé
   * Values locations are indicated in the translation key by their index between braces ({0], {1}, ...})
   */
  public translateKey(pKey: string, pParams?: string[], orDie?: string): string {
    return WizCoreTranslationManager.getInstance().translateKey(pKey, pParams, orDie);
  }

}
